export enum MASTER_TYPE_REF {
  SALES_TRACKING_DATE_FILTER = "SALES_TRACKING_DATE_FILTER",
}
